import { loggerService }  from "@contorion/core/services/logger.service";
import { Component }  from "@contorion/core/components/component";
import {BundleComponent, GaEcommerceItem} from "../interfaces/ga4-event.interface";

export abstract class Ga4EcommerceComponent extends Component {
    protected eventName: string;

    protected constructor(element: HTMLElement, eventName: string) {
        super(element);

        this.eventName = eventName;
        if (window.tc_vars) {
            this.fire();
        } else {
            loggerService.error(`${this.eventName} failed`);
        }
    }

    protected abstract fire(): void;

    protected getProductItems(): GaEcommerceItem[] {
        const items: GaEcommerceItem[] = [];
        const tcVars = window.tc_vars;
        const price = Array.isArray(tcVars.product_unitprice_ati) ? tcVars.product_unitprice_ati[0] : tcVars.product_unitprice_ati;
        if(tcVars.product_is_bundle === '1') {
            items.push({
                item_id: tcVars.product_id,
                item_name: tcVars.product_name,
                index: 0,
                item_brand: '',
                item_category: '',
                item_category2: '',
                item_category3: '',
                item_category4: '',
                bundle_id: tcVars.product_bundle_id,
                bundle_name: tcVars.product_bundle_name,
                price: parseFloat(price),
                quantity: 1,
                is_bundle: true
            });
            tcVars.product_bundle_components.forEach((obj: BundleComponent)=>{
                items.push({
                    item_id: obj.product_id,
                    item_name: obj.product_name,
                    index: parseInt(obj.product_bundle_component_sort),
                    item_brand: obj.product_trademark,
                    item_category: obj.product_cat1,
                    item_category2: obj.product_cat2,
                    item_category3: obj.product_cat3,
                    item_category4: obj.product_cat4,
                    bundle_id: obj.product_bundle_id,
                    bundle_name: obj.product_bundle_name,
                    price: parseFloat(obj.product_unitprice_ati),
                    quantity: parseInt(obj.product_quantity),
                    is_bundle_component: obj.product_is_bundle_component === '1'
                });
            })
        }
        else {
            items.push({
                item_id: tcVars.product_id,
                item_name: tcVars.product_name,
                index: 0,
                item_brand: tcVars.product_trademark,
                item_category: tcVars.product_cat1,
                item_category2: tcVars.product_cat2,
                item_category3: tcVars.product_cat3,
                item_category4: tcVars.product_cat4,
                price: parseFloat(price),
                quantity: 1
            });
        }
        return items;
    }
}
